import React, {useContext,useState,useRef} from 'react';
import MainLayoutPage from '../Common/MainLayoutPage';
import {NavControls} from '../Common/NavControls';
import * as Constants from '../Common/CommonConstants';
import {RenderDoneDialog} from '../Common/RenderDoneDialog';
import QuestionnaireFormCodeEntry from './QuestionnaireFormCodeEntry';
import {KeyEntryDialog, KeyEntryControl} from './KeyEntryDialog';
import {QuestionnaireCodeProvider,QuestionnaireCodeContext} from './QuestionnaireCodeContext';
import {FormList} from '../Home/FormList';



export default function CompCode(props) {

    
    const  questionnaireRef= useRef(null);

    return (
        <div>
            <QuestionnaireCodeProvider>
                <MainLayoutPage navControls=
                    {
                        <BuildNavControls questionnaireRef={questionnaireRef}/>
                    } 
                    contentArea=
                    {
                        <ContentArea questionnaireRef={questionnaireRef} {...props}/>
                    }>

                </MainLayoutPage>
            </QuestionnaireCodeProvider>
        </div>
    )
    
}

const BuildNavControls = (questionnaireRef) => {
    
    const {formState,updateFormState} = useContext(QuestionnaireCodeContext);
    
    return <NavControls questionnaireRef={questionnaireRef} formState={formState} updateFormState={updateFormState}
                                     readOnlyText="Return to enter code screen" cancelText="Cancel"  />
}


const ContentArea = ({questionnaireRef,...props}) => {

    const {formState,key1,key2,formData,setCompleteState, doneMessage,openPortal,formList} = useContext(QuestionnaireCodeContext);

    if (formState === Constants.DONE_MODE)
        return ReEnterKeyMode(openPortal,doneMessage,props);
    else if (formState === Constants.ENTER_KEY_MODE)
        return <KeyEntryDialog afterCodeConfirmationAction={openPortal} buttonText="Open Portal" {...props}></KeyEntryDialog>
    else if (formState === Constants.PORTAL_MODE)
        return <FormList forms={formList}></FormList>
    

    return <QuestionnaireFormCodeEntry ref={questionnaireRef} directLoadedForm={formData} completed
        handleRefresh={() => setCompleteState()}
        readOnlyMode={(formState === Constants.READ_ONLY_MODE)}
        key1={key1}
        key2={key2}
        {...props} />
      
}

const ReEnterKeyMode=(openPortal,doneMessage,props)=>{

    var addOptionText = 
    <div>
            or open the form again
        <br/>
        <br/>
        return <KeyEntryControl afterCodeConfirmationAction={openPortal} buttonText="Open Portal" {...props}></KeyEntryControl>
    </div>

    return RenderDoneDialog(doneMessage,true,addOptionText)
}








